import { useEffect, useState } from 'react';
import parseHtml from 'html-react-parser';

type AdminMessageBodyLoaderPureProps = {
  content: string | JSX.Element | JSX.Element[];
};

const AdminMessageBodyLoaderPure = ({
  content,
}: AdminMessageBodyLoaderPureProps): JSX.Element => <>{content}</>;

type MessageBodyLoaderProps = {
  s3URL: string | undefined;
};

const AdminMessageBodyLoader = ({
  s3URL,
}: MessageBodyLoaderProps): JSX.Element | null => {
  const [content, setContent] = useState<
    string | JSX.Element | JSX.Element[]
  >();

  useEffect(() => {
    if (s3URL && !content) {
      fetch(s3URL)
        .then((response) => {
          if (response.ok) {
            response.text()
            .then(value => setContent(parseHtml(value)))
            .catch(e => {throw e});
          }
        })
        .catch((error) =>
          console.error(`Error getting message body html ${s3URL}`, error),
        )
        .catch((error) =>
          console.error(`Error retrieving message body ${s3URL}`, error),
        );
    }
  }, [content, s3URL]);

  if (!content) {
    return null;
  }

  return <AdminMessageBodyLoaderPure content={content} />;
};

export default AdminMessageBodyLoader;